<template>
  <v-container fluid>
    <v-layout row>
      <Header title="O nás" subtitle="Firma vznikla v roku 1993 a v súčastnosti sa zaoberáme:" />
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
  name: "About",
  components: {
    Header
  }
};
</script>

<style>
</style>